import React, { useState, useEffect, useRef } from 'react'
import {Form, Button, Spinner, Row, Col, InputGroup } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import { useProvider, Toast } from '../context/MenuProvider';
import AOS from "aos";
import 'aos/dist/aos.css';

const ClienteList = () => {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [clientes, setClientes] = useState([]);
    const [results, setResults] = useState([]);
    const [limpar, setLimpar] = useState(true);
    const [filtroCliente, setFiltroCliente] = useState('todos');
    const [nextUrl, setNextUrl] = useState(null);
    const [avancada, setAvancada] = useState(false);
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDados,
      navigateTo,
      buscarDadosPorId,
    } = useProvider();
    
    const { get, del, loading } = crud ||{};

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const pagina = queryParams.get('tipo')?.toLowerCase();
  

    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
    }, []);
    
    useEffect(()=>{
      const novosItens = results;
      const novaBusca = limpar;
      setClientes((itensAnteriores) => {
                  const mapa = new Map();
                
                  // Adiciona os anteriores ao mapa
                  itensAnteriores.forEach((c) => mapa.set(c.id, c));
                
                  // Atualiza ou adiciona os novos
                  novosItens.forEach((c) => mapa.set(c.id, c));
                
                  if (novaBusca) {
                    // Apenas mantém os que vieram na nova busca
                    return novosItens.map((c) => mapa.get(c.id));
                  } else {
                    // Mescla mantendo os anteriores e atualizando os que vieram
                    return Array.from(mapa.values());
                  }
                });
    }, [results]);
    
    function filtroAvancadoCliente(item, query, filtroCliente, avancada = false) {
      const hoje = new Date();
      const compras = parseInt(item.numero_de_compras || 0);
      const debito = parseFloat(item.total_aberto || 0);
      const ultimaCompra = item.data_ultima_compra
        ? new Date(item.data_ultima_compra).getTime()
        : null;
    
      const queryLower = query?.toLowerCase();
      const searchValido = queryLower
        ? item.nome_do_cliente?.toLowerCase().includes(queryLower)
        : true;
    
      let funcAvancada = true;
    
      switch (filtroCliente) {
        case "todos":
          funcAvancada = queryLower ? true : compras > 0;
          break;
    
        case "top10Compradores":
          funcAvancada = item.ativo && !item.is_inadimplente && compras > 0;
          break;
    
        case "semCompra":
          funcAvancada = item.ativo && compras === 0;
          break;
    
        case "comCompra":
          funcAvancada = !item.is_inadimplente && compras > 0;
          break;
    
        case "semDebito":
          funcAvancada = compras > 0 && debito === 0;
          break;
    
        case "comDebito":
          funcAvancada = compras > 0 && debito > 0;
          break;
    
        case "mais30":
        case "mais60":
        case "mais90":
          const dias = parseInt(filtroCliente.replace("mais", ""));
          const dataLimite = new Date(hoje);
          dataLimite.setDate(hoje.getDate() - dias);
    
          funcAvancada = item.ativo &&
                         compras > 0 &&
                         debito === 0 &&
                         ultimaCompra !== null &&
                         ultimaCompra <= dataLimite.getTime();
          break;
    
        case "inativo":
          funcAvancada = !item.ativo;
          break;
    
        case "inadimplentes":
          funcAvancada = item.is_inadimplente;
          break;
    
        default:
          funcAvancada = true;
          break;
      }
    
      return searchValido && funcAvancada;
    }
    
    const isConsultaCarregada = useRef(false);
    const carregarLocal = async()=>{
      try{
        let response;
        if(query || filtroCliente) {
          response = await buscarDados(
            'db_clientes',  
            item => filtroAvancadoCliente(item, query, filtroCliente, avancada),
            filtroCliente==="top10Compradores"?10:30,
            filtroCliente==="top10Compradores"?"total_em_pagamentos":filtroCliente==="mais90"?"data_ultima_compra":"nome_do_cliente",
            (filtroCliente==="top10Compradores"||filtroCliente==="mais90")?"desc":"asc",
          );
        }else{
          response = await buscarDados(
            'db_clientes',
            (item) => {
              return true;
            },
            30,
            "nome_do_cliente",
          );
        }
        if (isConsultaCarregada.current) return;
        if (response && response.length) {
          const base = response;
          setClientes(base);
        }
      }catch(err){

      } finally {

      }
    }

    // Função para buscar clientes na API
    const buscarClientes = async (novaBusca = false) => {
        setLimpar(novaBusca);
        let url = `/gvendas/clientes/?expand=regiao&filtros=id,telefone,ativo,numero_de_compras,tempo_ultima_compra,nome_do_cliente,nome,total_em_pagamentos,total_aberto,foto_perfil,foto_mapa,score,is_inadimplente,data_ultima_compra`;

        if (query) url += `&search=${query}`;
        
        
        const data = new Date();
        let formatada = data.toLocaleDateString('sv-SE');
        switch(filtroCliente){
          case "todos":
            if(!query) url+= `&ativo=true`;
            if(!avancada && !query) {
              url += `&ordering=nome_do_cliente`;
            } 
            break;
          case "top10Compradores":
            url += `&ativo=true&is_inadimplente=false&numero_de_compras__gt=0&ordering=-total_em_pagamentos,-total_aberto,-numero_de_compras,data_primeira_compra&limit=10`
            break;
          case "semCompra":
            url += `&ativo=true&numero_de_compras=0&ordering=-data_criacao,nome_do_cliente`;
            break;
          case "comCompra":
            url += `&is_inadimplente=false&numero_de_compras__gt=0&ordering=-data_ultima_compra`;
            break;
          case "semDebito":
            url += `&numero_de_compras__gt=0&total_aberto=0&ordering=-data_ultima_compra`;
            break;
          case "comDebito":
            url += `&numero_de_compras__gt=0&total_aberto__gt=0&ordering=-total_aberto`;
            break;
          case "mais30":
          case "mais60":
          case "mais90":
            const diasmais = parseInt(filtroCliente.replace("mais", ""));
            const dataLimitemais = new Date();
            dataLimitemais.setDate(dataLimitemais.getDate() - diasmais);
            
            const formatadamais = dataLimitemais.toLocaleDateString('sv-SE');
            url += `&ativo=true&numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lte=${formatadamais}&ordering=-data_ultima_compra`;
            break;
          case "inativo":
            url += `&ativo=false&numero_de_compras=0&ordering=nome_do_cliente`;
            break;
          case "inadimplentes":
            url += `&is_inadimplente=true&ordering=-total_aberto`;
            break;
          default:
            if(!query) url =+ `&ordering=nome_do_cliente`
            break;
        }
        
        if (novaBusca) {
            //setClientes([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        //alert(url)
        
        try {
            const response = await get(url, 'pagina');
            //alert(JSON.stringify(response));
            if (response && response.length) {
                isConsultaCarregada.current = true;
                const novosItens = response[0].results;

                setResults(novosItens);
                if(filtroCliente !== 'top10Compradores') setNextUrl(response[0].next);
            }
        } catch (err) {
          
            // alert(JSON.stringify(err.response))
            // Toast.fire({
            //     icon: "error",
            //     title: "Falha ao buscar clientes"
            // });
        } finally {
            
        }
    };
    
    
    
    // Carrega os clientes ao montar o componente ou aplicar um novo filtro
    const [isLoad, setIsLoad] = useState(false);

    // useEffect(()=>{
    //   const carregarBusca = async()=>{
    //     if(!isLoad){
    //       setIsLoad(true);
    //     } else {
    //       //buscarClientes(true);
    //       carregarLocal();
    //     }
    //   }
    //   carregarBusca();
    // },[query, filtroCliente])

    useEffect(()=>{
      carregarLocal();
      buscarClientes(true);
    },[query, filtroCliente])
    
    
    useEffect(()=>{
      switch(pagina){
        case 'debito':
          setFiltroCliente("comDebito");
          break;
        case 'clientes90':
          setFiltroCliente("mais90");
          break;
        case 'top10':
          setFiltroCliente("top10Compradores");
          break;
        default:
          setFiltroCliente("todos");
          break;
        
      }
    },[pagina])
    
    
    useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar produtos', to: '/estoque/sincronizar' },
        { name:'Importar Clientes', to: '/clientes/importar/'},
      ]);
      
      setBtns([
        {icon:'bi-funnel'+(avancada?'-fill':''), onClick:() => {setAvancada(!avancada); setFiltroCliente('todos');}},
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns, avancada, setAvancada]);
    



    
    // Detecta o fim da página para carregar mais clientes
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarClientes();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    const formatTelefone = (telefone) => {
      if (!telefone) return '';
      telefone = telefone.replace(/\D/g, '');
      if (!telefone) return '';
      return `+55${telefone}`;
    }
    const sendWhatsApp = (x)=>{
      const texto =`Oi ${x.nome_do_cliente.trimStart().split(' ')[0]}`
      const mensagem = encodeURIComponent(texto);
      const url = `whatsapp://send?${formatTelefone(x.telefone) ? `phone=${formatTelefone(x.telefone)}&` : ""}text=${mensagem}`;
      window.open(url);
    }
    
    const excluirCliente = (item) => {
      Swal.fire({
        title: "Exluir cliente?",
        text: "Você não poderá reverter isso!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim, excluir!"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            await del(`/gvendas/clientes/${item.id}/`);
            Toast.fire({
                icon: "success",
                title: `Cliente excluído com sucesso`
            });
            setClientes((prevItem) => prevItem.filter((cliente) => cliente !== item));
          }catch(err){
            Swal.fire({
              title: `Erro ${err.status}`,
              text: 'Cliente não pode ser excluído',
              icon: "error"
            });
          }finally{
            
          }
        }
      });
    }
    const ClienteDetalhesPadrao = (x) =>{
      return (<>
        <RenderizarProduto
          key={x.id} // Adição de key para cada produto
          to={`/clientes/${x.id}`}
          src={x.foto_perfil}
          text1={`${x.tempo_ultimo_contato ? 'ar. ' + x.tempo_ultimo_contato + '. ' : ''} ${x.numero_de_compras > 0 ? x.numero_de_compras + ' compra' + (x.numero_de_compras > 1 ? 's, última' : ',') + ' a ' + x.tempo_ultima_compra : ''}`}
          titulo={`${x.nome||x.nome_do_cliente}`}
          text2={`${x.numero_de_compras > 0 ? x.total_em_pagamentos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ' pago' : ''} ${x.total_aberto > 0 ? ' e ' + x.total_aberto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ' em aberto' : ''}`}
        />
      </>)
    }
    
    
    const ClienteDetalhes = (x) =>{
      return (<div className="my-1">
        <RenderizarProduto
          key={x.id} // Adição de key para cada produto
          //to={`/clientes/${x.id}`}
          col={!x.foto_mapa && !x.foto_perfil?'d-none':''}
          src={x.foto_perfil}
          bgimg={!x.foto_perfil?x.foto_mapa:''}
          text1 = {`${x.numero_de_compras > 0 ? x.numero_de_compras + ' compra' + (x.numero_de_compras > 1 ? 's, última' : ',') + ' ' + x.tempo_ultima_compra : ''}`}
          titulo={(<div onClick={()=>navigate(`/clientes/${x.id}`)} className="fs-4">{x.nome||x.nome_do_cliente}</div>)}
          text2={(<>
                {x.regiao?.nome && (<div>{x.regiao?.nome}</div>)}
                <Row>
                  <Col className="small">
                    {x.telefone}
                  </Col>
                  <Col xs="auto">
                    {x.endereco && (<Button onClick={()=>window.open(`https://www.google.com/maps/search/?api=1&query=${x.endereco}`)} variant="outline-secondary" className="btn-sm ms-1"><i className="bx bx-map"></i></Button>)}
                    {x.telefone && (<Button onClick={()=>sendWhatsApp(x)} variant="outline-success" className="btn-sm ms-1"><i className="bx bxl-whatsapp"></i></Button>)}
                    <Button onClick={()=>navigate(`/clientes/${x.id}`)} variant="outline-secondary" className="btn-sm ms-1"><i className="bx bx-user"></i></Button>
                    {!x.numero_de_compras && (<Button onClick={()=>excluirCliente(x)} variant="outline-danger" className="btn-sm ms-1"><i className="bx bx-trash"></i></Button>)}
                  </Col>
                  {x.observacoes && (<Col xs={12} className="mt-2">
                    {x.observacoes}
                  </Col>)}
                  {x.numero_de_compras>0 && (
                    <Col xs={12} className="mt-2 py-1 border-top">
                      <Row>
                          <Col>
                            {x.total_em_pagamentos>=0 && (<>
                              {parseFloat(x.total_em_pagamentos||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} {` pago `}
                            </>)}
                            {x.total_aberto>0 && (<>
                              {` e `}{parseFloat(x.total_aberto||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} {` em aberto `}
                            </>)}
                          </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
          </>)}
        />
      </div>)
    }

    return (
        <>
            <BotaoFlutuante to="/contatos/novo/cliente" icon="bi-plus" />
            <div className="">
                
        <Row>
          <Col className="fs-4">
            Destaques
          </Col>
          {pagina && (
            <Col xs="auto">
              <Button variant="outline-secondary" onClick={()=>navigate('', {replace:true})} className="btn-sm">
                <i className="bx bx-x"></i>
              </Button>
            </Col>
          )}
        </Row>
        <Destaques  pagina={pagina}  />
        <Row className="d-flex mt-3 justify-content-center align-items-center">
          <Col xs="auto" className="fs-4">
            Clientes
          </Col>
          <Col>
            <div className="input-group">
              <Form.Control 
                type="text" 
                placeholder="Pesquisar..." 
                value={query} 
                onChange={(e) => setQuery(e.target.value)} 
              />
              <Button variant="secondary" onClick={() => buscarClientes(true)}>
                <i className="bi bi-search"></i>
              </Button>
            </div>
          </Col>
        </Row>
                  {avancada && (
                  <>
                    <Form.Group controlId="formSelectClientFilter" className="mt-3">
                        <InputGroup>
                          <span className="input-group-text">Filtro</span>
                          <Form.Control 
                              as="select" 
                              value={filtroCliente} 
                              onChange={(e) => setFiltroCliente(e.target.value)}
                          >
                              <option value="todos">Todos</option>
                              <option value="comCompra">Clientes</option>
                              <option value="semCompra">Contatos sem compra</option>
                              <option value="comDebito">Clientes com débito</option>
                              <option value="semDebito">Clientes sem débito</option>
                              <option value="mais30">Mais de 30 dias sem comprar</option>
                              <option value="mais60">Mais de 60 dias sem comprar</option>
                              <option value="mais90">Mais de 90 dias sem comprar</option>
                              <option value="inadimplentes">Inadimplentes</option>
                              <option value="inativo">Inativo</option>
                          </Form.Control>
                          <Button variant="secondary" onClick={() => buscarClientes(true)}>
                              Buscar
                          </Button>
                        </InputGroup>
                    </Form.Group>

                  </>
                  )}
                
                <div className="list-group mt-3">
                    {clientes.length > 0 ? (
                        clientes.map((x, index) => (
                          <div>
                            {filtroCliente === "top10Compradores" && (
                              <div className="mt-2">Top {index+1}</div>
                            )}
                            {ClienteDetalhes(x)}
                          </div>
                        ))
                    ) : (
                          !(loading) && <div className="text-center text-muted">
                            Nenhum cliente encontrado.
                            <p>
                              Você já tem uma lista de clientes?<br />
                              <Button variant="outline-dark" onClick={()=>navigateTo('/clientes/importar/')}>Importe com mais agilidade</Button>
                            </p>
                          </div>
                    )}
                    {(loading) && <p  className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !(loading) && (
                        <Button variant="secondary" data-aos="fade-up" onClick={() => buscarClientes(false)} className="mt-2">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};


const Destaques = ({pagina})=>{
  const [receber, setReceber] = useState(0);
  const [count, setCount] = useState(0);
  const [top10Valor, setTop10Valor] = useState(0);
  const {
    crud,
    salvarDados,
    buscarDadosPorId,
  } = useProvider();
  const { get } = crud || {};
  const navigate = useNavigate();
  
  useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
  }, []);
  
  useEffect(()=>{
    const updateDados = async (data, id) => {
      try {
        var atualizado = {
          ...data,
          id:"destaque_clientes_info",
        }
        await salvarDados('local_registros', atualizado);
      } catch (err) {
        //alert(JSON.stringify(err))
        console.error(err);
      }
    };
    const carregarLocal = async()=>{
      try{
        const response = await buscarDadosPorId('local_registros', "destaque_clientes_info");
        if(response){
          const base = response;
          setReceber(base?.receber);
          setCount(base?.clientes90);
          setTop10Valor(base?.top10valor);
        }
      }catch(err){
        
      }finally{
        carregarContagem();
      }
    }
    const carregarContagem = async()=>{
      try{
        const data = new Date();
        data.setDate(data.getDate() - 90);
        const formatada = data.toLocaleDateString('sv-SE'); // sueco padrão
        const urls =[
          `/gvendas/clientes/?ativo=true&total_aberto__gt=0&limit=1&filtros=id&expand=extra`,
          `/gvendas/clientes/?ativo=true&numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lte=${formatada}&limit=1&filtros=id`,
          `/gvendas/clientes/?ativo=true&is_inadimplente=false&numero_de_compras__gt=0&ordering=-total_em_pagamentos&filtros=total_em_pagamentos&limit=10`,
        ]
        const response = await get(urls, "destaque_clientes_info");
        if(response && response.length){
          setReceber(response[0].extra?.total_aberto);
          setCount(response[1].count);
          const top10valor = response[2].results.reduce((sum, x) => sum + parseFloat(x.total_em_pagamentos), 0);
          setTop10Valor(top10valor);
          updateDados({
            'receber':response[0].extra?.total_aberto,
            'clientes90':response[1].count,
            'top10valor': top10valor
          });
        }
      }catch(err){
        //alert(JSON.stringify(err))
      }
    }

    carregarLocal();
  },[])
  
  
  return (<div className="list-group mt-2">
    <div data-aos="fade-up">
      <RenderizarProduto
        key={1}
        lm='my-1'
        bcolor={pagina === 'debito'?'red':''}
        //to={`?tipo=debito`}
        onClick={()=>navigate('?tipo=debito', {replace:true})}
        //src={`/images/img_fiado.jpg`}
        icon="bx bx-money-withdraw text-muted"
        className="rounded-circle img-fluid"
        text1={`Clientes com débitos`}
        text2={`Receba até ${parseFloat(receber || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`}
      />
    </div>  
    <div data-aos="fade-up" data-aos-delay={50}>
      <RenderizarProduto
        key={1}
        lm='my-1'
        bcolor={pagina === 'clientes90'?'red':''}
        //to={`?tipo=clientes90`}
        onClick={()=>navigate('?tipo=clientes90', {replace:true})}
        //src={`/images/img_parcial.jpg`}
        icon="bx bx-time-five text-muted"
        className="rounded-circle img-fluid"
        text1={`Mais tempo sem comprar`}
        text2={`${count} clientes com mais de 3 meses`}
      />
    </div>  
    <div data-aos="fade-up" data-aos-delay={100}>
      <RenderizarProduto
        key={1}
        lm='my-1'
        bcolor={pagina === 'top10'?'red':''}
        //to={`?tipo=top10`}
        onClick={()=>navigate('?tipo=top10', {replace:true})}
        //src={`/images/img_parcial.jpg`}
        icon="bx bx-star text-muted"
        className="rounded-circle img-fluid"
        text1={`Top 10 compradores`}
        text2={`${parseFloat(top10Valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} vendidos`}
      />
    </div>  
  </div>)
}


export default ClienteList;